import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const LawSection = styled.div`
  margin-top: 55px;
`;

const LawBasis = styled.p`
  font-size: 0.88rem;
  color: #777;
  margin-bottom: 16px;

  strong { color: #223E7E; }
`;

const LawDesc = styled.p`
  font-size: 0.95rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 18px;

  strong { color: #c0392b; }
`;

const TableWrap = styled.div`
  overflow-x: auto;
  margin-bottom: 24px;
`;

const LawTable = styled.table`
  width: 100%;
  min-width: 520px;
  border-collapse: collapse;
  font-size: 0.92rem;

  th, td {
    border: 1px solid #e5e5e5;
    padding: 12px 16px;
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    background: #223E7E;
    color: #fff;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
  }

  td.period {
    font-weight: 700;
    color: #223E7E;
    white-space: nowrap;
    text-align: center;
  }
`;

const LawNote = styled.p`
  background: #f8f9fa;
  border-left: 4px solid #223E7E;
  padding: 16px 20px;
  border-radius: 0 8px 8px 0;
  font-size: 0.92rem;
  color: #555;
  line-height: 1.75;
`;

const BusinessDisinfection = () => {
  return (
    <SubLayout
      title="소독업"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_cad.jpg"
    >
      <Intro>
        주식회사 두성시스템은 소독업 신고를 바탕으로 전문 방역·방제 서비스를 제공합니다.
        <strong> 감염병 예방을 위한 정기 소독</strong>과 해충 구제를 통해 위생적이고 안전한
        생활·업무 환경을 조성합니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🦠</div>
          <h4>방역·방제</h4>
          <p>세균·바이러스 방역과 해충 방제로 위생적인 환경을 유지합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🐛</div>
          <h4>해충 구제</h4>
          <p>바퀴·개미·쥐 등 유해 해충에 대한 전문 구제 서비스를 수행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🧴</div>
          <h4>정기 소독</h4>
          <p>주기적인 소독 프로그램으로 청결한 위생 상태를 지속 관리합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🛡️</div>
          <h4>감염병 예방 소독</h4>
          <p>다중이용시설 등에 대한 감염병 예방 소독을 신속하게 제공합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">📜</div>
          <h4>법정소독 기준</h4>
          <p>감염병의 예방 및 관리에 관한 법률에 따라 정기적인 소독과 증명서 발급까지 완벽하게 처리합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>전문 방역 인력</h4>
        <p>소독업 신고 요건을 갖춘 전문 인력이 직접 시행하여 신뢰도 높은 방역을 실현합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>안전한 약제 사용</h4>
        <p>인체와 환경에 안전한 승인 약제를 사용하여 안심할 수 있는 소독을 제공합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>정기 방역 프로그램</h4>
        <p>시설 특성에 맞춘 정기 방역 계약으로 지속적인 위생 관리를 지원합니다.</p>
      </FeatureBox>

      <LawSection>
        <SectionLabel>법정 소독 의무 안내</SectionLabel>
        <LawBasis>
          <strong>법적 근거</strong> · 「감염병의 예방 및 관리에 관한 법률」 제51조, 시행령 제24조, 시행규칙 제36조 [별표 7]
        </LawBasis>
        <LawDesc>
          법으로 정한 시설의 관리·운영자는 감염병 예방을 위한 정기 소독을 실시해야 하며,
          실시하지 않으면 <strong>100만원 이하의 과태료</strong>가 부과됩니다.
        </LawDesc>

        <TableWrap>
          <LawTable>
            <thead>
              <tr>
                <th>시설 유형 (예시)</th>
                <th>4~9월</th>
                <th>10~3월</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>숙박업소·식품접객업소·대규모점포·병원 등 다중이용시설</td>
                <td className="period">1개월마다 1회</td>
                <td className="period">2개월마다 1회</td>
              </tr>
              <tr>
                <td>학교·학원·사무실용 건축물(2,000㎡↑)·공연장·기숙사 등</td>
                <td className="period">2개월마다 1회</td>
                <td className="period">3개월마다 1회</td>
              </tr>
              <tr>
                <td>공동주택(300세대 이상)</td>
                <td className="period">3개월마다 1회</td>
                <td className="period">6개월마다 1회</td>
              </tr>
            </tbody>
          </LawTable>
        </TableWrap>

        <LawNote>
          두성시스템은 시설 유형에 맞는 법정 소독 주기를 준수하여 정기 소독을 실시하고, 소독 증명서 발급까지 처리해 드립니다.
        </LawNote>
      </LawSection>
    </SubLayout>
  );
};

export default BusinessDisinfection;
